var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9545 11C17.9545 9.62451 17.5466 8.27992 16.7824 7.13625C16.0183 5.99258 14.9321 5.1012 13.6613 4.57482C12.3906 4.04845 10.9922 3.91073 9.64319 4.17907C8.29414 4.44741 7.05496 5.10977 6.08235 6.08238L11 11H17.9545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08235 6.08238C4.77812 7.38661 4.04541 9.15553 4.04541 11C4.04541 12.8444 4.77812 14.6134 6.08235 15.9176L11 11L6.08235 6.08238Z",
    fill: "#6FB1D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08235 15.9176C7.05496 16.8902 8.29414 17.5526 9.64319 17.8209C10.9922 18.0892 12.3906 17.9515 13.6613 17.4251C14.9321 16.8988 16.0183 16.0074 16.7824 14.8637C17.5466 13.7201 17.9545 12.3755 17.9545 11H11L6.08235 15.9176Z",
    fill: "#DB5F7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/cz.ebecbadf33c1825a85f4632242fca765.svg";
export { ForwardRef as ReactComponent };